import { notifications } from '@mantine/notifications';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { api, podatki } from '../api/odjemalec';
import { sporocilo } from '../api/napaka';
import { seja } from '../seja/seja';
import { glave, obNapaki } from './zeton';

/**
 * Prijava kot uporabnik instance (brez {@code prijavaId} kot uporabnik, ki se je nazadnje prijavil): strežnik vrne
 * dostopni žeton te prijave, aplikacija nato dela kot ta uporabnik (rumen trak v glavi, »Končaj«). {@code dela} je
 * ključ gumba, ki se izvaja.
 */
export function usePrijavaKot() {
  const navigate = useNavigate();
  const [dela, setDela] = useState<string | null>(null);
  const prijavi = async (companyId: number, prijavaId?: number) => {
    setDela(`${companyId}-${prijavaId ?? ''}`);
    try {
      const o = await podatki(
        api.POST('/api/skrbnik/instance/{companyId}/prijava-kot', {
          headers: glave(),
          params: { path: { companyId }, query: { prijavaId } },
        }),
      );
      seja.prijaviKot(o);
      void navigate('/');
    } catch (e) {
      obNapaki(e);
      notifications.show({ color: 'red', message: sporocilo(e) });
    } finally {
      setDela(null);
    }
  };
  return { prijavi, dela: (companyId?: number, prijavaId?: number) => dela === `${companyId}-${prijavaId ?? ''}` };
}
